import { Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    fileId?: number
}

const DownloadDocument : React.FC<Props> = ({fileId}) => {
    const {t} = useTranslation("common");
    
    return <>
        {fileId && <Button href={`${window.location.origin}/api/document/download/${fileId}`} target='__blank' type="button" variant="text">{t("common.download")}</Button>}
    </>
}

export default DownloadDocument;